import { FileUploadModule } from 'primeng/fileupload';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlannerOrderformComponent } from './pages/orderform/orderform.component';
import { PlannerOrderformJobinformationComponent } from './pages/orderform/partials/orderform-jobinformation/orderform-jobinformation.component';
import { PlannerOrderformTemplateComponent } from './pages/orderform/partials/orderform-template/orderform-template.component';
import { PlannerOrderformCandidateComponent } from './pages/orderform/partials/orderform-candidate/orderform-candidate.component';
import { PlannerOrderformDateComponent } from './pages/orderform/partials/orderform-date/orderform-date.component';
import { PlannerOrderformParticipantsComponent } from './pages/orderform/partials/orderform-participants/orderform-participants.component';
import { PlannerOrderformDocumentsComponent } from './pages/orderform/partials/orderform-documents/orderform-documents.component';
import { PlannerOrderformOwnObserversComponent } from './pages/orderform/partials/orderform-own-observers/orderform-own-observers.component';
import { PlannerConfirmationComponent } from './pages/confirmation/confirmation.component';
import { TranslocoRootModule } from '../transloco/transloco-root.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from '../shared/shared.module';
import { ParticipantFormComponent } from './partials/participant-form/participant-form.component';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { MomentModule } from 'ngx-moment';
import { TooltipModule } from 'primeng/tooltip';
import { CoreModule } from 'projects/core/src/public-api';
import { DialogModule } from 'primeng/dialog';

@NgModule({
  declarations: [
    PlannerOrderformComponent,
    PlannerOrderformJobinformationComponent,
    PlannerOrderformTemplateComponent,
    PlannerOrderformCandidateComponent,
    PlannerOrderformDateComponent,
    PlannerOrderformParticipantsComponent,
    PlannerOrderformOwnObserversComponent,
    PlannerOrderformDocumentsComponent,
    ParticipantFormComponent,
    PlannerConfirmationComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    TranslocoRootModule,
    MomentModule,
    ButtonModule,
    TableModule,
    TooltipModule,
    DialogModule,
    FileUploadModule,
    CoreModule
  ]
})
export class OrdersModule { }
